<script lang="ts">
	//Formating
	import { format } from 'svelte-i18n';
	// Components
	import type { VCInterfaceStatus } from 'src/types/VirtualComponents';

	export let temperature: VCInterfaceStatus;
	export let precipitation: VCInterfaceStatus;
</script>

<div class="weather-content">
	<div class="weather-metric">
		<div class="metric-header">
			<i class="fas fa-thermometer-half"></i>
			<span>{$format('title_chart_temperature', { default: 'Temperature' })}</span>
		</div>
		<div class="metric-value">
			<span class="value">{temperature?.value}</span>
			<span class="subtitle">{$format('weather_6h_average', { default: '6h average' })}</span>
		</div>
	</div>
	<div class="weather-metric">
		<div class="metric-header">
			<i class="fas fa-cloud-rain"></i>
			<span
				>{$format('weather_widget_precipitation', {
					default: 'Precipitation',
				})}</span
			>
		</div>
		<div class="metric-value">
			<span class="value">{precipitation?.value}</span>
			<span class="subtitle">{$format('weather_24h_forecast', { default: '24h forecast' })}</span>
		</div>
	</div>
</div>

<style>
	.weather-content {
		display: flex;
		gap: 18px;
	}
	.weather-metric {
		border-radius: 12px;
		padding: 12px 14px;
		width: 130px;
		max-width: 150px;
		background-color: #1b1e20;
		display: flex;
		flex-direction: column;
		gap: 8px;
	}
	.metric-header {
		display: flex;
		align-items: center;
		gap: 6px;
		color: #606263;
		font-size: 12px;
	}
	.metric-header i {
		font-size: 14px;
	}
	.metric-value {
		display: flex;
		flex-direction: column;
		gap: 4px;
	}
	.metric-value .value {
		font-size: 16px;
		font-weight: 600;
		color: white;
	}
	.metric-value .subtitle {
		font-size: 12px;
		color: #8e8e93;
	}
</style>
